export function isMobileAgent() {
  var ua = navigator.userAgent.toLocaleLowerCase();
  var agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  return agents.some(function (agent) {
    return ua.includes(agent.toLocaleLowerCase());
  });
}